// https://fettblog.eu/typescript-assertion-signatures/
function defineProperty(a,b,c){Object.defineProperty(a,b,c)}export{defineProperty};